import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=a2ed0766&"
import script from "./baseEdit.vue?vue&type=script&lang=js&"
export * from "./baseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports